import actionCreatorFactory from "typescript-fsa";
import { MenuLikeRequestBody } from "../../core/api/requests/menu/like/types";
import { MenuSearchRequestBody } from "../../core/api/requests/menu/search/types";
import { CommonAsyncType } from "../../core/types";
import { Category, MenuInCart } from "./types";

const actionCreator = actionCreatorFactory("@@Menu");

export const menuActions = {
  getMenus: actionCreator.async<CommonAsyncType<Category[]> & MenuSearchRequestBody, Category[]>("GET_MENUS"),
  getMenusFromCart: actionCreator.async<CommonAsyncType, MenuInCart[]>("GET_MENUS_FROM_CART"),
  setMenuInCart: actionCreator.async<CommonAsyncType & { menus: MenuInCart[] }, MenuInCart[]>("SET_MENU_IN_CART"),
  addMenuToCart: actionCreator.async<CommonAsyncType & MenuInCart, MenuInCart[]>("ADD_MENU_TO_CART"),
  addCouponMenusToCart: actionCreator.async<CommonAsyncType & { menus: MenuInCart[] }, MenuInCart[]>("ADD_COUPON_MENUS_TO_CART"),
  removeMenuFromCart: actionCreator.async<CommonAsyncType & { index: number }, MenuInCart[]>("REMOVE_MENU_FROM_CART"),
  removeMenuFromCartByCouponUuids: actionCreator.async<CommonAsyncType<MenuInCart[]> & { couponUuids: string[]; isDeleteOnce?: boolean }, MenuInCart[]>(
    "REMOVE_COUPON_MENU_FROM_CART",
  ),
  setFavoriteMenu: actionCreator.async<CommonAsyncType & MenuLikeRequestBody, {}>("SET_FAVORITE_MENU"),
  setMenusToReorder: actionCreator<MenuInCart[]>("SET_MENUS_TO_REORDER"),
  cancelReorder: actionCreator("CANCEL_REORDER"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
